import { ArticleFilterValues, ArticleGetResponse, ArticleParams, ArticleValues } from '../model/articleModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export enum ARTICLE_TYPES {
  SET_API_ARTICLE_REQUEST_STATE = 'SET_API_ARTICLE_REQUEST_STATE',
  SET_API_ARTICLE_REQUEST_ERROR = 'SET_API_ARTICLE_REQUEST_ERROR',
  SET_API_ARTICLES_REQUEST_STATE = 'SET_API_ARTICLES_REQUEST_STATE',
  SET_API_ARTICLES_REQUEST_ERROR = 'SET_API_ARTICLES_REQUEST_ERROR',
  ADD = 'ARTICLE_ADD',
  EDIT = 'ARTICLE_EDIT',
  DELETE = 'ARTICLE_DELETE',
  GET_ONE = 'ARTICLE_GET_ONE',
  GET_ONE_SUCCESS = 'ARTICLE_GET_ONE_SUCCESS',
  GET_ALL = 'ARTICLE_GET_ALL',
  GET_ALL_SUCCESS = 'ARTICLE_GET_ALL_SUCCESS',
  RESET = 'ARTICLE_RESET',
  RESET_ALL = 'ARTICLE_RESET_ALL',
}

export interface SetApiArticleRequestStateAction {
  type: ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_STATE;
  payload: {
    apiArticleRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiArticleRequestErrorAction {
  type: ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_ERROR;
  payload: {
    apiArticleRequestError: string;
  };
}

export interface SetApiArticlesRequestStateAction {
  type: ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_STATE;
  payload: {
    apiArticlesRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiArticlesRequestErrorAction {
  type: ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_ERROR;
  payload: {
    apiArticlesRequestError: string;
  };
}

export interface AddArticleAction {
  type: ARTICLE_TYPES.ADD;
  payload: {
    article: ArticleValues;
  };
}

export interface ResetArticleAction {
  type: ARTICLE_TYPES.RESET;
  payload: null;
}

export interface ResetArticlesAction {
  type: ARTICLE_TYPES.RESET_ALL;
  payload: null;
}

export interface EditArticleAction {
  type: ARTICLE_TYPES.EDIT;
  payload: {
    article: ArticleValues;
    params: ArticleParams;
  };
}

export interface DeleteArticleAction {
  type: ARTICLE_TYPES.DELETE;
  payload: {
    params: ArticleParams;
  };
}
export interface GetOneArticleAction {
  type: ARTICLE_TYPES.GET_ONE;
  payload: {
    params: ArticleParams;
  };
}

export interface GetAllArticlesAction {
  type: ARTICLE_TYPES.GET_ALL;
  payload: {
    articleFilter: ArticleFilterValues;
  };
}

export interface GetOneArticleSuccessAction {
  type: ARTICLE_TYPES.GET_ONE_SUCCESS;
  payload: {
    article: ArticleGetResponse;
  };
}

export interface GetAllArticlesSuccessAction {
  type: ARTICLE_TYPES.GET_ALL_SUCCESS;
  payload: {
    articles: ArticleGetResponse[];
  };
}

export type ArticleActions =
  | SetApiArticleRequestStateAction
  | SetApiArticleRequestErrorAction
  | SetApiArticlesRequestStateAction
  | SetApiArticlesRequestErrorAction
  | AddArticleAction
  | EditArticleAction
  | ResetArticleAction
  | ResetArticlesAction
  | GetOneArticleAction
  | GetOneArticleSuccessAction
  | GetAllArticlesAction
  | GetAllArticlesSuccessAction;

export interface ArticleState {
  apiArticleRequestState: API_REQUEST_STATE;
  apiArticleRequestError: string | null;
  apiArticlesRequestState: API_REQUEST_STATE;
  apiArticlesRequestError: string | null;
  tags: string[];
  article: ArticleGetResponse;
  articles: ArticleGetResponse[];
}
